import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Input } from 'reactstrap'
import SearchIcon from "../../../static/images/search_icon.svg"
import { DateHeader } from '../helpers/header'
import { DateHeaderMobile } from '../helpers/header-mobile'
import { FONTS } from '../../../constants'

export const MyTimesheet = class extends React.Component {
  state={ tempSearch: this.props.searchTimesheet }

  render() {
    return (
      <Wrapper>
        <SearchField
          placeholder='Search by project'
          value={ this.state.tempSearch }
          onChange={ (e) => {
            if (e.target.value === '') this.props.handleChangeSearch(e.target.value)
            this.setState({ tempSearch: e.target.value })
          }
          }
          onKeyDown={ (e) => {
            if (e.keyCode === 13) this.props.handleChangeSearch(this.state.tempSearch)
          } }
        />
        <DateHeader dates={ this.props.dates } />
        {/* header timesheet mobile */}
        <DateHeaderMobile
          dates={ this.props.dates }
          weekdates={ this.props.weekdates }
          { ...this.props }
        />
        {/* header timesheet mobile */}
      </Wrapper>
    )
  }
}

MyTimesheet.propTypes = {
  dates: PropTypes.array,
  weekdates: PropTypes.array,
  handleChangeSearch: PropTypes.func,
  searchTimesheet: PropTypes.string,
}
MyTimesheet.defaultProps = {
  dates: [],
  weekdates: [],
  handleChangeSearch: () => {},
  searchTimesheet: '',
}

const Wrapper = styled.div`
  width: 100%;
  z-index: 2;
  background-color: #ffffff ;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
  @media (max-width: 575.98px) {
    position: fixed;
  }
  @media (max-width: 767.98px) {
    position: fixed;
  }
`
const SearchField = styled(Input)`
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
  height: 30px;
  width: 30%;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 10px;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 1% !important;
  margin-right: 1% !important;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  z-index: 999 !important;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`




// WEBPACK FOOTER //
// ./src/components/timesheet/search-bar/my-timesheet.js